import { authHTTP } from "./axios.service";
import { HandleFilters } from "@/services/filters.service";
import store from "@/store";

class RecordsService {
  list(filters) {
    // filters: A dict of key:value pairs
    let page_size = store.getters["core/pageSize"];
    let queryString = HandleFilters(filters, page_size);
    return authHTTP.get("records/" + queryString);
  }

  create(payload) {
    // payload: A dict containing { candidate, task, instructor }
    return authHTTP.post("records/", payload);
  }

  get(id) {
    // id: the id of the record to be retrieved
    return authHTTP.get("records/" + id + "/");
  }

  getPdf(id) {
    // id: the id of the record to be retrieved
    return authHTTP.get("records/" + id + "/pdf/");
  }

  getEmail(id) {
    // id: the id of the record to be retrieved
    return authHTTP.get("records/" + id + "/email/");
  }

  update(payload) {
    // payload: The record model to be updated
    return authHTTP.patch("records/" + payload.id + "/", payload);
  }

  getItems(id) {
    // id: the id of the record the items belong to
    return authHTTP.get("records/" + id + "/items/");
  }

  updateItem(payload) {
    // paylod: The item model to be updated
    let url = "records/" + payload.record + "/items/" + payload.id + "/";
    return authHTTP.patch(url, payload);
  }

  createItem(payload) {
    // payload: record (id) and item competency reference
    let url = "records/" + payload.record + "/items/";
    return authHTTP.post(url, payload);
  }

  destroyItem(payload) {
    // payload: record (id) and item (id)
    let url = "records/" + payload.record + "/items/" + payload.item + "/";
    return authHTTP.delete(url);
  }

  signExam(payload) {
    // payload: A model of the signature data (id, username, sig code)
    return authHTTP.patch("records/" + payload.id + "/sign/", payload);
  }

  getFile(idx) {
    return authHTTP.get("records/users/" + idx + "/");
  }

  listFiles() {
    return authHTTP.get("records/users/");
  }

  listTasks() {
    return authHTTP.get("tasks/");
  }

  listCompetencies() {
    return authHTTP.get("competencies/");
  }

  listMarkers() {
    return authHTTP.get("markers/");
  }

  listReasonCodes() {
    return authHTTP.get("reasons/");
  }

  listScannedRecord(query) {
    let page_size = store.getters["core/pageSize"];
    let queryString = HandleFilters(query, page_size);
    return authHTTP.get("scanned-records/" + queryString);
  }

  createScannedRecord(payload) {
    return authHTTP.post(
      "scanned-records/",
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
  }

  getScannedRecord(id) {
    return authHTTP.get("scanned-records/" + id + "/");
  }

  updateScannedRecord(payload) {
    let url = "scanned-records/" + payload.id + "/";
    return authHTTP.patch(url, payload.formData);
  }

  getScannedRecordTypes() {
    return authHTTP.get("scanned-records/types/");
  }

  getScannedRecordTags() {
    return authHTTP.get("scanned-records/tags/");
  }

}

export default new RecordsService();
